import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const StaffDetailsList = () => {
  const handleDelete = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/staffs/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setStaffs((prevStaffs) =>
        prevStaffs.filter((staff) => staff.personalDetails.staffId !== id)
      );
      toast.success("Staff deleted successfully.");
    } catch (error) {
      console.error("Error deleting staff:", error);
      toast.error("Failed to delete staff.");
    }
  };

  const [staffs, setStaffs] = useState([]);

  useEffect(() => {
    // Fetch staff details from the backend
    const fetchStaffs = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/staffs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setStaffs(response.data);
      } catch (error) {
        console.error("Error fetching staff details:", error);
        toast.error("Failed to load staff details.");
      }
    };

    fetchStaffs();
  }, []);

  return (
    <>
      <div className="container mt-5 bg-white rounded p-5 mb-5">
        <div className="row">
          <div className="row mb-3 d-flex justify-content-between align-items-center">
            {/* Back Button */}
            <div className="col-auto">
              <Link to="/erp/staffs" className="btn btn-secondary">
                &#8592; Back
              </Link>
            </div>

            {/* Centered Heading */}
            <div className="col-auto text-center">
              <h3 className="text-success">School Staff List</h3>
            </div>
          </div>
          <div className="table-responsive mt-4">
            <table className="table table-striped table-hover table-bordered text-center">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Staff Name</th>
                  <th>Staff ID</th>
                  <th>Designation</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {staffs.length > 0 ? (
                  staffs.map((staff, index) => (
                    <tr key={staff.personalDetails.staffId}>
                      <td>{index + 1}</td>
                      <td>{staff.personalDetails.staffName}</td>
                      <td>{staff.personalDetails.staffId}</td>
                      <td>{staff.professionalDetails.designation}</td>
                      <td>
                        <Link
                          to={`/erp/staffs/edit/${staff.personalDetails.staffId}`}
                          className="btn btn-sm btn-warning mx-2"
                        >
                          Edit
                        </Link>

                        {/* <button
                          className="btn btn-sm btn-danger"
                          onClick={() =>
                            handleDelete(staff.personalDetails.staffId)
                          }
                        >
                          Delete
                        </button> */}

                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#deleteModal2"
                        >
                          Delete Staff
                        </button>

                        <div
                          className="modal fade"
                          id="deleteModal2"
                          tabIndex="-1"
                          aria-labelledby="exampleModalLabel2"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h1
                                  className="modal-title fs-5"
                                  id="exampleModalLabel2"
                                >
                                  Confirm Deletion
                                </h1>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body text-start">
                                Do you want to delete the staff details ?
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  data-bs-dismiss="modal"
                                >
                                  Close
                                </button>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleDelete(staff.personalDetails.staffId)
                                  }
                                  className="btn btn-danger"
                                  data-bs-dismiss="modal"
                                >
                                  Delete Staff
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No staff details found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default StaffDetailsList;
